// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5c478847","455":"2940f525"}[chunkId] + ".chunk.js";
};